import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as IconPlus } from '../../images/icon-plus.svg';
import { ReactComponent as IconMinus } from '../../images/icon-minus.svg';

export function ZoomControls({ onZoomIn = () => {}, onZoomOut = () => {} }) {
    return (
        <div className="seatmap-controls">
            <div className="seatmap-controls-zoombutton" onClick={onZoomIn}>
                <IconPlus />
            </div>
            <div className="seatmap-controls-zoombutton" onClick={onZoomOut}>
                <IconMinus />
            </div>
        </div>
    );
}

ZoomControls.propTypes = {
    onZoomIn: PropTypes.func,
    onZoomOut: PropTypes.func,
};
